import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import '@indigo-ag/component-module/static/fonts/Circular/circular.css';

import './core/i18n';
import { getClient } from 'core/apollo/client';
import { store } from 'store';
import { Root } from 'core/containers/Root/Root';
import './global-styles/index.css';

getClient().then(client =>
  render(
    <ApolloProvider client={client}>
      <Provider store={store}>
        <Root />
      </Provider>
    </ApolloProvider>,
    document.getElementById('root') as HTMLElement
  )
);
